import {
    useCallback,
    useState
} from "react";

import Box from "@mui/material/Box";
import { Paper } from "@mui/material";
import { SignUpConfirmationForm } from "./SignUpConfirmationForm";
import { SignUpForm } from "./SignUpForm";

export const CreateUserPage = () => {
    const [email, setEmail] = useState<string | undefined>(undefined);
    const [showConfirmationPage, setShowConfirmationPage] = useState<boolean>(false);

    const assignEmailAndShowConfirmationPage = useCallback((email: string) => {
        //ensure the user redirects to landing page for initial sign in
        window.history.pushState({}, "", "/");
        setShowConfirmationPage(true);
        setEmail(email);
    }, []);


    return (
        <Box
            height="100vh"
            width="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
        >
            <Paper sx={{ p: 1, m: 2 }} variant="outlined">
                {showConfirmationPage && email != undefined ?
                    <SignUpConfirmationForm
                        email={email!}
                    /> :
                    <SignUpForm
                        onAccountCreated={assignEmailAndShowConfirmationPage}
                    />
                }
            </Paper>
        </Box>
    );
};